import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <div className="flex-shrink-0 relative" style={{ left: '-5%', top: '5%' }}>
            <button
              onClick={scrollToTop}
              className="cursor-pointer"
            >
              <img 
                src="https://static.readdy.ai/image/5946f8dc6d1689a139aced3671fb829b/5627d08f05dce4eda6468c71266b611d.png" 
                alt="Premium Oto Logo" 
                className="h-40 sm:h-44 w-auto object-contain"
              />
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <button
              onClick={() => scrollToSection('services')}
              className={`font-sans text-sm font-medium tracking-wide hover:text-accent-gold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              HİZMETLER
            </button>
            <button
              onClick={() => scrollToSection('why-choose-us')}
              className={`font-sans text-sm font-medium tracking-wide hover:text-accent-gold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              NEDEN BİZ
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className={`font-sans text-sm font-medium tracking-wide hover:text-accent-gold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              YORUMLAR
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-sans text-sm font-medium tracking-wide hover:text-accent-gold transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-800' : 'text-white'
              }`}
            >
              İLETİŞİM
            </button>
            <button
              onClick={() => scrollToSection('appointment')}
              className="bg-black text-white px-6 py-2 font-sans text-sm font-medium tracking-wide hover:bg-accent-gold transition-all whitespace-nowrap cursor-pointer"
            >
              RANDEVU AL
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 cursor-pointer ${
              isScrolled ? 'text-black' : 'text-white'
            }`}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left font-sans text-sm font-medium text-gray-800 hover:text-accent-gold transition-colors cursor-pointer py-2"
            >
              HİZMETLER
            </button>
            <button
              onClick={() => scrollToSection('why-choose-us')}
              className="block w-full text-left font-sans text-sm font-medium text-gray-800 hover:text-accent-gold transition-colors cursor-pointer py-2"
            >
              NEDEN BİZ
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="block w-full text-left font-sans text-sm font-medium text-gray-800 hover:text-accent-gold transition-colors cursor-pointer py-2"
            >
              YORUMLAR
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left font-sans text-sm font-medium text-gray-800 hover:text-accent-gold transition-colors cursor-pointer py-2"
            >
              İLETİŞİM
            </button>
            <button
              onClick={() => scrollToSection('appointment')}
              className="block w-full bg-black text-white px-6 py-3 font-sans text-sm font-medium tracking-wide hover:bg-accent-gold transition-all whitespace-nowrap cursor-pointer text-center mt-2"
            >
              RANDEVU AL
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}